import * as React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { AppProvider } from './src/context/App'

// ToastContainer lives here (above the page subtree) so it survives Gatsby
// route changes; a page-scoped container would unmount on `navigate(...)` and
// silently drop any toast queued just before the navigation.
const Provider = ({ element }) => (
  <AppProvider>
    {element}
    <ToastContainer
      position='bottom-left'
      autoClose={5000}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </AppProvider>
)

export default Provider
